import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Form from 'components/Form';

import {
  OrderEditMainForm_order$key,
  OrderStatus,
} from '__generated__/OrderEditMainForm_order.graphql';
import { OrderEditMainFormMutation } from '__generated__/OrderEditMainFormMutation.graphql';
import { useNotification } from 'components/Notifications';

type FormValues = {
  adminComment: string;
  status: OrderStatus;
};

type Props = {
  order: OrderEditMainForm_order$key;
};

const OrderEditMainForm: FC<Props> = ({ children, order }) => {
  const { pop } = useNotification();

  const { id, adminComment, status } = useFragment(
    graphql`
      fragment OrderEditMainForm_order on Order {
        id
        adminComment
        status
      }
    `,
    order
  );

  const [update, loading] = useMutation<OrderEditMainFormMutation>(graphql`
    mutation OrderEditMainFormMutation($order: UpdateOrderInput!) {
      updateOrder(order: $order) {
        id
      }
    }
  `);

  const initial: FormValues = {
    adminComment: adminComment ?? '',
    status: status,
  };

  const handleSubmit = useCallback(
    (order: FormValues) => {
      update({
        variables: {
          order: {
            id,
            ...order,
          },
        },
        onError: error => {
          console.log(error);
        },
        onCompleted: (response, errors) => {
          pop('Išsaugota');
        },
      });
    },
    [id, pop, update]
  );

  return (
    <Formik<FormValues> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={loading}>{children}</Form>
    </Formik>
  );
};

export default OrderEditMainForm;
